import axios from "axios";
import {BASE_URL} from "../BaseUrl.js"


axios.interceptors.request.use(
    function (config) {
      const token = localStorage.getItem("babiSolde_api");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        config.headers.Authorization = null;
      }
  
      return config;
    },
    function (error) {
      console.log("AN ERROR REQUEST", error);
    }
  );
  
  //liste des Commandes
  
  export const listeDesCommandes = async (page, size, param) => {
    // return await axios.get(`${BASE_URL}/parametres/allCategorie`), {});
    return await axios.get(
      `${BASE_URL}/Commandes/allCommandes?page=${page}&size=${size}&param=${param}`,
      {}
    );
  };

  //liste categorie sans filters
export const listeCommandesansFiltre = async () => {
  // return await axios.get(`${BASE_URL}/parametres/allCategorie`), {});
  return await axios.get(`${BASE_URL}/Commandes/allCommandes`, {});
};
  
  // Enregiste des Commandes
  
  export const enregistrerCommandes = async (Commandes) => {
    return await axios.post(`${BASE_URL}/Commandes`, Commandes);
  };
  
  // modifie categorie
  
  export const modifierCommandesById = async (CommandesId, CommandesData) => {
    return await axios.put(
      `${BASE_URL}/Commandes/${CommandesId}`,
      CommandesData
    );
  };
  
  // supprimer une categorie
  
  export const supprimerCommandesById = async (CommandesId) => {
    return await axios.delete(`${BASE_URL}/Commandes/${CommandesId}`);
  };
  